<!-- 登录 -->
<style scoped>
  .el-container{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  .login-content {
    /* min-width: 1200px; */
    width: 100%;
    /* height: 865px; */
    height: 100%;
    overflow: hidden;
    position: relative;
    background: #fff;
  }
  .login-content .formCont{
    width: 340px;
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translateX(-50%);
  }
  .login-content .formCont p{
    font-size: 24px;
    color: #353E5A;
    text-align: center;
  }
  .login-content .formCont p.small{
    font-size: 17px;
    color: #989AA6;
    margin-bottom: 60px;
  }
  .login-content .formCont img{
    width: 13px;
    height: 15px;
    position:absolute;
    z-index: 9999;
    top: 12px;
    left: 18px;
  }
  .header-cont {
    width: 100%;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
    padding: 90px 0 0 30%;
  }

  .header-cont > .logo {
    float: left;
    width: 55px;
    margin: 0 10px 0;
  }

  .header-cont > .logo img {
    width: 100%;
  }

  .login-form {
    display: block;
    margin: 0 auto;
    /* width: 360px; */
    width: 100%;
    font-size: 13px;
    margin-bottom: 12px;
    background: #3B404F;
    color:#fff
  }
  .login-ruleform{
    background: #353E5A;
    width: 100%;
    margin: 45px auto 0;
    display: block;
    font-size: 16px;
    color: #fff;
    border-radius: 0!important;
    height: 55px;
  }
  .forgetPwd{
    text-align: right;
    color: #989AA6;
    font-size: 11px;
  }
  .forgetPwd a{
    color: #989AA6;
  }

  /* .user-img {
    top: 30px;
    margin: 0 auto;
    display: block;
    position: relative;
    right: 140px;
  } */
  .login-footer{
    width: 100%;
    font-size: 11px;
    color: #989AA6;
    text-align: center;
    line-height: 72px;
    position: absolute;
    bottom: 0;
    left: 0;
  }

</style>

<style>
  .login-content .el-input {
    /* width: 360px; */
    display: block;
    margin: 0 auto;
  }

  .login-content .el-input__inner {
    padding-left: 38px;
    border-radius: 20px !important;
    background-color: transparent!important;
    border: none!important;
    color: #606266;
  }
  .login-content .el-input__inner:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    box-shadow: 0 0 0px 1000px white inset;
  }

  .login-content .el-form-item__error {
    left: 25px;
  }

  .login-content .el-form-item {
    margin-bottom: 0px;
  }

  .login-content .el-form-item__content {
    /* width: 360px; */
    margin: 0 auto;
    height: 45px;
    margin-bottom:40px;
    border-bottom: 2px solid #353E5A;
  }
  .icon-close {
    width:14px;
    height:14px;
    display: inline-block;
    background-repeat: no-repeat;
    background-image: url("../assets/images/closeeyes.png");
  }
</style>
<template>
    <el-container>
      <div class="login-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="formCont">
          <p>欢迎登录</p>
          <p class="small">Welcome!</p>
          <el-form-item prop="userNo">
            <img src="../assets/images/store/icon_login_user1.png"/>
            <el-input type="text" placeholder="请输入您的账号" v-model="ruleForm.userNo" @keyup.enter.native="login('ruleForm')" class="imgblock"/>
          </el-form-item>
          <el-form-item v-if="visible" prop="password">
            <img src="../assets/images/store/icon_login_password1.png"/>
            <el-input  type="password" placeholder="请输入您的密码" v-model="ruleForm.password" @keyup.enter.native="login('ruleForm')">
              <i slot="suffix" title="显示密码" @click="changePass('show')" style="cursor:pointer;" class="el-icon-view"></i>
            </el-input>
          </el-form-item>
          <el-form-item v-else prop="password">
            <img src="../assets/images/store/icon_login_password1.png"/>
            <el-input  type="text" placeholder="请输入密码" v-model="ruleForm.password" @keyup.enter.native="login('ruleForm')">
              <i slot="suffix" title="隐藏密码" @click="changePass('hide')" style="cursor:pointer;" class="icon-close"></i>
            </el-input>
          </el-form-item>
          <div class="forgetPwd">
            <span @click="loginMer(merLink + '/resetPwd/forget')" style="cursor: pointer;">忘记密码？</span>
          </div>
          <el-button class="login-ruleform" @click="login('ruleForm')" v-loading.fullscreen.lock="fullscreenLoading">立即登录</el-button>
        </el-form>
      </div>
    </el-container>
</template>

<script>
  import Footer from "@/components/common/Footer";
  import { userLogin , queryStaffVoice, listAreaInfo} from '../api/index.js'
  import CryptoJS from 'crypto-js'

  export default {
    name: "Login",
    components: {
      Footer
    },
    data() {
      return {
        visible: true ,
        isLoging: false,
        fullscreenLoading: false,
        ruleForm: {
          userNo: "",
          password: "",
        },
        rules: {
          userNo: [
            {required: true, message: '账号不能为空', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '密码不能为空', trigger: 'blur'}
          ]
        },
        merLink:'http://store.meishealth.com/#'
      };
    },
    methods: {
      changePass(value) {
        this.visible = !(value === 'show');
      } ,   //判断渲染，true:暗文显示，false:明文显示
      operaEntryDES(message) {
        var keyHex = CryptoJS.enc.Utf8.parse("VIP20198888*7*6*5*4**88882088VIP");
        var encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
      },
      //登录逻辑
      login(formName) {
        localStorage.removeItem('user')
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.fullscreenLoading = true;
            const loading = this.$loading({
              lock: true,
              background: 'rgba(0, 0, 0, 0)'
            });

            //一般要跟后端了解密码的加密规则
            //这里例子用的哈希算法来自./js/sha1.min.js
            // let password_sha = this.password;

            //需要想后端发送的登录参数
            // 判断是否是手机号，手机号是老板roleFlag:1，否则是员工roleFlag:2
            let postData = {
              roleFlag: /^1[3456789]\d{9}$/.test(this.ruleForm.userNo) ? 1 : 2,
              username: this.ruleForm.userNo.replace(/\s+/g, ""),
              password: this.operaEntryDES(this.ruleForm.password.replace(/\s+/g, ""))
            };
            //设置在登录状态
            this.isLogin = false;
            this.$store.commit("setRoleFlags", postData.roleFlag);

            //请求后端:
           const  date  = userLogin(postData);
              date.then((response) => {
                 // console.log(response)
                if (response.code == 1) {
                  let expireDays = 1000 * 60 * 60 * 24 * 15;
                  this.setCookie('session', response.session, expireDays);

                  let userInfo = {};
                  if(/^1[3456789]\d{9}$/.test(this.ruleForm.userNo)){
                    // 老板 门店信息
                    userInfo.storeList = response.data.storeList;
                  }else{
                    userInfo = response.data.store;
                    userInfo.storeCode = response.data.storeCode;
                    queryStaffVoice({
                      staffId:response.data.staffId
                    }).then(voiceres=>{
                      userInfo.setVoiceStatus = voiceres.data.isOpen;
                      if(voiceres.data.isOpen){
                        this.setVoiceMp3(true,voiceres.data.staffId);
                      }
                    })
                  }
                  // 个人信息
                  userInfo.staffName = response.data.staffName;
                  userInfo.staffId = response.data.staffId;
                  userInfo.staffPhone = response.data.staffPhone;
                  userInfo.redisKey = response.data.redisKey;

                  // 最大 折扣 优惠 抹零
                  userInfo.maxDiscount = response.data.maxDiscount;
                  userInfo.maxMaling = response.data.maxMaling;
                  userInfo.maxPreferential = response.data.maxPreferential;

                  this.$store.commit("updateUserInfo", userInfo);
                  localStorage.setItem('user', JSON.stringify(userInfo))

                  if(response.data.resourceList.length == 0){
                    this.$message({
                      message: '暂无权限，不可登录！',
                      type: 'error'
                    });
                    return;
                  }else{
                    this.$store.commit("setResourceList", response.data.resourceList);
                  }
                  //登录成功后
                  this.isLogin = true;
                  // debugger;
                  if (this.isLogin) {
                    sessionStorage.setItem(this.loginCacheName , 'loging');
                    // console.log('session----'+sessionStorage.getItem('isLogin'))
                  }

                  // 省市区存储
                  listAreaInfo({}).then(areares=>{
                    this.$store.commit('setProvincialCity',areares.data)
                  })

                  //登录成功后
                  setTimeout(() => {
                    this.fullscreenLoading = false;
                    loading.close();
                    if(/^1[3456789]\d{9}$/.test(this.ruleForm.userNo)){
                      // 若老板只有一家门店，则直接进入该门店系统 若老板由两家及以上门店时，需先进入选择门店页，选择具体的门店后才可以进入门店
                      if(response.data.storeList.length > 1){
                       this.loginMer(this.merLink + '/allStore');//老板账号 所有门店选择
                        return;
                      }else{
                        this.loginMer(this.merLink + '/bossCenter'); //老板账号 门店
                        return;
                      }
                    }else{
                      this.loginMer(this.merLink + response.data.resourceList[0].url);
                      return;
                    }
                  }, 500);
                }else{
                  this.fullscreenLoading = false;
                  loading.close();
                  this.$message({
                  message: response.msg,
                  type: 'error'
                });
                }
              })
              .catch((error) => {
                this.fullscreenLoading = false;
                loading.close();
                this.$message({
                  message: '网络连接失败，请稍后再试',
                  type: 'error'
                });
              })
          }
        });
      },
      loginMer(e){
        top.location.href = e
      },
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/loginMe.vue